export const SampleBadge = ({ show, testid }) => (show ? (
  <span title="Example profile to show how Balqis Book works. Not a real company."
    className="inline-flex items-center rounded-md border border-[#B45309]/40 bg-[#FFF4E5] px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide text-[#92400E]"
    data-testid={testid || "sample-badge"}>Sample</span>
) : null);
